import React from "react";
import Cardealer_01 from '../Assets/png/car_dealer01.png';
import Cardealer_02 from '../Assets/png/car_dealer02.png';
import Cardealer_03 from '../Assets/png/car_dealer03.png';
import Cardealer_04 from '../Assets/png/car_dealer04.png';
import Cardealer_05 from '../Assets/png/car_dealer05.png';
import Cardealer_06 from '../Assets/png/car_dealer06.png';
import Cardealer_07 from '../Assets/png/car_dealer07.png';
import Cardealer_08 from '../Assets/png/car_dealer08.png';


class Cardealer extends React.Component{
    render(){
        return(
            <>
                <div className="container">
                        <center ><h3 className="cardel_heading">car dealers</h3></center>
                        <center><h1 className="cardel_heading2">best dealers in your <span className="cardel_heading3"> city</span></h1></center>
                        <center><div className="car_space"></div></center>
                        <div className="row" style={{margin:"0"}}>
                            <div className="col-lg-3 col-xs-12">
                                <div className="cardel_style">
                                    <img src={Cardealer_01} className="img-responsive cardel_bg"/>
                                    <div className="cardel_size">
                                        <a href="#" className="cardel_name"><h4>automotive gear</h4></a>
                                        <p className="cardel_add"><span className="glyphicon glyphicon-map-marker cardel_gly"></span> 25/b milford, new york</p>
                                        <a href="#" className="cardel_ph"><p><span className="glyphicon glyphicon-earphone cardel_gly"></span> +2 123 654 7898</p></a>
                                        <span className="cardel_list">25 listing</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-xs-12">
                                <div className="cardel_style">
                                    <img src={Cardealer_02} className="img-responsive cardel_bg"/>
                                        <div className="cardel_size">
                                        <a href="#" className="cardel_name"><h4>keithson car</h4></a>
                                        <p className="cardel_add"><span className="glyphicon glyphicon-map-marker cardel_gly"></span> 25/b milford, new york</p>
                                        <a href="#" className="cardel_ph"><p><span className="glyphicon glyphicon-earphone cardel_gly"></span> +2 123 654 7898</p></a>
                                        <span className="cardel_list">35 listing</span>
                                    </div>
                                </div>
                             </div>
                            <div className="col-lg-3 col-xs-12">
                                <div className="cardel_style">
                                    <img src={Cardealer_03} className="img-responsive cardel_bg"/>
                                    <div className="cardel_size">
                                        <a href="#" className="cardel_name"><h4>superious automotive</h4></a>
                                        <p className="cardel_add"><span className="glyphicon glyphicon-map-marker cardel_gly"></span> 25/b milford, new york</p>
                                        <a href="#" className="cardel_ph"><p><span className="glyphicon glyphicon-earphone cardel_gly"></span> +2 123 654 7898</p></a>
                                        <span className="cardel_list">15 listing</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-xs-12">
                                <div className="cardel_style">
                                    <img src={Cardealer_04} className="img-responsive cardel_bg"/>
                                    <div className="cardel_size">
                                        <a href="#" className="cardel_name"><h4>racing car</h4></a>
                                        <p className="cardel_add"><span className="glyphicon glyphicon-map-marker cardel_gly"></span> 25/b milford, new york</p>
                                        <a href="#" className="cardel_ph"><p><span className="glyphicon glyphicon-earphone cardel_gly"></span> +2 123 654 7898</p></a>
                                        <span className="cardel_list">20 listing</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row" style={{margin:"0"}}>
                            <div className="col-lg-3 col-xs-12">
                                <div className="cardel_style">
                                    <img src={Cardealer_05} className="img-responsive cardel_bg"/>
                                    <div className="cardel_size">
                                        <a href="#" className="cardel_name"><h4>car showromio</h4></a>
                                        <p className="cardel_add"><span className="glyphicon glyphicon-map-marker cardel_gly"></span> 25/b milford, new york</p>
                                        <a href="#" className="cardel_ph"><p><span className="glyphicon glyphicon-earphone cardel_gly"></span> +2 123 654 7898</p></a>
                                        <span className="cardel_list">19 listing</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-xs-12">
                                <div className="cardel_style">
                                    <img src={Cardealer_06} className="img-responsive cardel_bg"/>
                                    <div className="cardel_size">
                                        <a href="#" className="cardel_name"><h4>fastspeedio car</h4></a>
                                        <p className="cardel_add"><span className="glyphicon glyphicon-map-marker cardel_gly"></span> 25/b milford, new york</p>
                                        <a href="#" className="cardel_ph"><p><span className="glyphicon glyphicon-earphone cardel_gly"></span> +2 123 654 7898</p></a>
                                        <span className="cardel_list">40 listing</span>
                                    </div>
                                </div>
                             </div>
                            <div className="col-lg-3 col-xs-12">
                                <div className="cardel_style">
                                    <img src={Cardealer_07} className="img-responsive cardel_bg"/>
                                    <div className="cardel_size">
                                        <a href="#" className="cardel_name"><h4>star automall</h4></a>
                                        <p className="cardel_add"><span className="glyphicon glyphicon-map-marker cardel_gly"></span> 25/b milford, new york</p>
                                        <a href="#" className="cardel_ph"><p><span className="glyphicon glyphicon-earphone cardel_gly"></span> +2 123 654 7898</p></a>
                                        <span className="cardel_list">59 listing</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-xs-12">
                                <div className="cardel_style">
                                    <img src={Cardealer_08} className="img-responsive cardel_bg"/>
                                    <div className="cardel_size">
                                        <a href="#" className="cardel_name"><h4>superspeed auto</h4></a>
                                        <p className="cardel_add"><span className="glyphicon glyphicon-map-marker cardel_gly"></span> 25/b milford, new york</p>
                                        <a href="#" className="cardel_ph"><p><span className="glyphicon glyphicon-earphone cardel_gly"></span> +2 123 654 7898</p></a>
                                        <span className="cardel_list">28 listing</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
                <br/>
                <br/><br/>
            </>
        )
    }
}

export default Cardealer;